import { render, staticRenderFns } from "./UploadV2.vue?vue&type=template&id=3b3afb1a&scoped=true&"
import script from "./UploadV2.vue?vue&type=script&lang=js&"
export * from "./UploadV2.vue?vue&type=script&lang=js&"
import style0 from "./UploadV2.vue?vue&type=style&index=0&id=3b3afb1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3afb1a",
  null
  
)

export default component.exports